import { PaginationResponse } from '@/app/types'
import { BasicTable, BasicTableProps } from './BasicTable'

interface PaginatedTableProps<T>
  extends Omit<
    BasicTableProps<T>,
    'getPageCount' | 'getPageIndex' | 'handleNextPage' | 'handlePreviousPage'
  > {
  pagination: PaginationResponse | undefined
  onChangeSkip: (skip: number) => void
}

export const PaginatedTable = <T,>({
  pagination,
  onChangeSkip,
  ...props
}: PaginatedTableProps<T>) => {
  const getPageIndex = () => {
    if (!pagination) return 0
    return Math.floor((pagination.skip ?? 0) / (pagination.limit ?? 1)) + 1
  }

  const getPageCount = () => {
    if (!pagination) return 0
    return Math.ceil((pagination.total ?? 0) / (pagination.limit ?? 1))
  }

  const handleNextPage = () => {
    if (!pagination) return
    const newPage = (pagination.skip ?? 0) / (pagination.limit ?? 1) + 1
    if (getPageCount() === getPageIndex()) return
    const skipValue = newPage * (pagination.limit ?? 1)
    onChangeSkip(skipValue)
  }

  const handlePreviousPage = () => {
    if (!pagination) return
    const newPage = (pagination.skip ?? 0) / (pagination.limit ?? 1) - 1
    if (newPage < 0) return
    const skipValue = newPage * (pagination.limit ?? 1)
    onChangeSkip(skipValue)
  }

  return (
    <BasicTable<T>
      {...props}
      getPageCount={getPageCount}
      getPageIndex={getPageIndex}
      handleNextPage={handleNextPage}
      handlePreviousPage={handlePreviousPage}
    />
  )
}
